import { z } from 'zod';
import { AdminPageQuerySchema, adminPage } from './page';

/* Audit log */
export const AuditEntrySchema = z.object({
  id: z.string(),
  actorHandle: z.string(),
  action: z.string(),
  targetType: z.string(),
  targetId: z.string(),
  reason: z.string(),
  createdAt: z.iso.datetime(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;

export const AdminAuditQuerySchema = AdminPageQuerySchema.extend({
  actor: z.string().max(64).optional(),
  action: z.string().max(64).optional(),
  targetType: z.string().max(32).optional(),
  /** ISO date (inclusive lower bound). */
  since: z.string().max(32).optional(),
});
export type AdminAuditQuery = z.infer<typeof AdminAuditQuerySchema>;

export const AuditResponseSchema = adminPage(AuditEntrySchema);
export type AuditResponse = z.infer<typeof AuditResponseSchema>;
